import React from "react";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";

import { DEFAULT_PLAN_TYPE } from "../../../consts/planTypes";
import { palette } from "../../../theme/palette";

import { numberWithCommas } from "../../../utils/routes";

import {
  depotSummaryInformation,
  getMatrixProfileType,
  areasWaveSplitSelector,
  driverlessRoutesSelector,
} from "../../../reducers/matrixProfile/selectors";

import { View } from "../../Base";
import DutyWarningComponent from "../DutyWarningComponent";
import OpportunityTimeComponent from "../OpportunityTimeComponent";
import UnallocatedPostcodeComponent from "../UnallocatedPostcodeComponent";
import SingleWaveComponent from "../SingleWaveComponent";
import DriverlessRoutesComponent from "../DriverlessRoutesComponent";
import MoreInfoComponent from "../MoreInfoComponent";
import KeyValue from "../KeyValue";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  clockIcon: {
    width: "16px",
    height: "16px",
  },
  warningIcon: {
    width: "16px",
    height: "14.45",
  },
  questionMarkIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const WaveSummaryPanel = () => {
  const styles = useStyles();
  const depotSummaryInfo = useSelector(depotSummaryInformation);
  const planType = useSelector(getMatrixProfileType);
  const { unallocatedAreas, singleWaveAreas } = useSelector(
    areasWaveSplitSelector
  );
  const driverlessRoutes = useSelector(driverlessRoutesSelector);

  return (
    <View className={styles.container}>
      <MoreInfoComponent waveMode />

      <KeyValue
        property={"Routes"}
        value={numberWithCommas(
          depotSummaryInfo?.timeBandFigures?.totalAllocated || 0
        )}
      />
      <KeyValue
        property={"Stops"}
        value={`${numberWithCommas(
          depotSummaryInfo?.timeBandFigures?.totalStops || 0
        )} (${numberWithCommas(
          depotSummaryInfo?.timeBandFigures?.stopsPercentage || 0
        )}%)`}
      />
      <KeyValue
        property={"Parcels"}
        value={`${numberWithCommas(
          depotSummaryInfo?.timeBandFigures?.totalParcels || 0
        )} (${numberWithCommas(
          depotSummaryInfo?.timeBandFigures?.parcelsPercentage || 0
        )}%)`}
      />
      <KeyValue
        property={"Collections"}
        value={numberWithCommas(depotSummaryInfo?.totalCollections || 0)}
      />

      <DutyWarningComponent />
      <OpportunityTimeComponent />

      {planType === DEFAULT_PLAN_TYPE && (
        <UnallocatedPostcodeComponent unallocatedAreas={unallocatedAreas} />
      )}
      {planType === DEFAULT_PLAN_TYPE && (
        <SingleWaveComponent singleWaveAreas={singleWaveAreas} />
      )}
      <DriverlessRoutesComponent driverlessRoutes={driverlessRoutes} />
    </View>
  );
};

export default WaveSummaryPanel;
